// No React import needed for this component
import clsx from 'clsx';
import GuestSidebar from './GuestSidebar';
import type { GuestLayoutProps } from '../../types/layout';

function GuestLayout({
  children,
  title,
  showAuthButtons = true,
  className,
}: GuestLayoutProps) {
  return (
    <div className={clsx('min-h-screen bg-gray-50', className)}>
      {/* Set page title */}
      {/* eslint-disable lingui/no-unlocalized-strings */}
      {title && <title>{title} - Instapaper</title>}
      {/* eslint-enable lingui/no-unlocalized-strings */}

      {/* Sidebar */}
      {showAuthButtons && <GuestSidebar />}

      {/* Main Content with margin for sidebar */}
      <main className={clsx('min-h-screen', showAuthButtons && 'ml-56')}>
        <div className="min-h-screen bg-white">{children}</div>
      </main>
    </div>
  );
}

export default GuestLayout;
